import { Component, OnInit, Input } from '@angular/core';
import { DetailsQueries } from '../../queries/details.queries';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { DetailsLocationQuery } from '../../interfaces/detail-location.query';
import { AsyncPipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
    selector: 'lib-seller-location',
    templateUrl: './seller-location.component.html',
    styleUrls: ['./seller-location.component.scss'],
    imports: [TranslocoDirective, AsyncPipe]
})
export class SellerLocationComponent implements OnInit {
  @Select(DetailsQueries.location) location$: Observable<DetailsLocationQuery>;
  @Input() showHeading = true;

  constructor() { }

  ngOnInit() {
  }

}
